var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-4"},[_c('vs-avatar',{attrs:{"badge":_setup.newUpdates,"text":"Luisdaniel"},on:{"click":function($event){return _setup.openChangelogs()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }